/**
 * Stringify Slate node for debug purposes (e.g. error messages).
 *
 * Node structure will be dumped as JSON-like output, with "text" and
 * "children" properties collapsed to `...` to keep the message clean.
 */
export function describeNode(node) {
  var parts = Object.entries(node).map(_ref => {
    var [key, value] = _ref;
    if (key === 'text' && typeof value === 'string' && value.length > 3) {
      return "".concat(JSON.stringify(key), ": \"...\"");
    }
    if (key === 'children' && Array.isArray(value) && value.length > 0) {
      return "".concat(JSON.stringify(key), ": [...]");
    }
    return "".concat(JSON.stringify(key), ": ").concat(JSON.stringify(value));
  });
  return "{".concat(parts.join(', '), "}");
}